<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
import Select from "@/components/c-select";
import Choosen from "@/components/c-select-choose";
import { servicehelpers } from "../../../services/servicehelpers";
import { propertyService } from "../../../services/propertyservice/property.service";
import { priceversionService } from "../../../services/propertyservice/priceversion.service";
import i18n from "../../../i18n";
import Loader from "../../../components/widgets/loader";
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Property Update Price",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loader, 
    Button,
    Input,
    Area,
    Select,
    Choosen,
    VSwatches
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "property",
      currency: "",
      breadCrumb: {},
      
      valueProject: 0,
      projectDataList: {},
      valueGroup: 0,
      groupDataList: {},
      valueProperties: null,
      propertyDataList: {},
      lastPriceVersionData: null,
      valueChanged: 0,
      changedText: '%',
      valueChangedType: 0,
      changedTypeDataList: {},
      valueNotation: '',
      valueExclude: 0,
      valueDeduction: 0,
      
      valueVersion: 0,
      valueVersionName: '',
      valueNow: this.$moment().clone().format('YYYY-MM-DD'),

      valueSoldColor: '#070215',
      valueBookingColor: '#dfeb14'
    };
      
  },
  mounted() {
    
    this.loadingDiscountTypeData();
    this.loadingProjectData();
    
    this.valueProject = 1;
    this.valueChangedType = 1;
    this.changedText = "%";

    this.loadingGroupData(this.valueProject);
    this.loadingPropertyData();

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 

    this.loadingLastPriceVersion(this.valueProject);
  },

  methods: {
    loadingData: function(id) {
      // console.log("AAAAAA", id);
      this.fetchingStats = false;
      propertyService.getOne(id)
        .then(response => {
          // console.log(response);

          if(response.data == null) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "property-add"
            });
          }

          this.breadCrumb = {
            text: response.data.code,
            active: true,
          };

          this.fetchingStats = true;
          this.propertyData = response;
          
        });
    },

    loadingGroupData: function(projectId = 0) {
      servicehelpers.getGroupData(projectId).then(response => {
        this.groupDataList = response;

        // console.log(JSON.stringify(response.data));
      });
    },

    loadingProjectData: function() {
      servicehelpers.getProjectData().then(response => {
        this.projectDataList = response;
      });
    },

    loadingPropertyData: function(projectId = 0, groupId = 0) {

      propertyService.getAvailable(projectId, groupId).then(response => {
        this.propertyDataList = response;
      });
    },

    loadingDiscountTypeData: function() {

      servicehelpers.getDiscountTypeData().then(response => {
        this.changedTypeDataList = response;
      });
    },

    loadingLastPriceVersion: function(projectId) {

      priceversionService.last(projectId).then(response => {
        this.lastPriceVersionData = response.data;
        this.valueVersion = response.data ? response.data.version + 1 : 1;

        // console.log(JSON.stringify(response.data));
      });
    },

    projectChanged: function(event) {
      // console.log(event);
      this.loadingPropertyData(event);
      this.loadingLastPriceVersion(event);
    },

    groupChanged: function(event) {
      // console.log(event);
      this.loadingPropertyData(this.valueProject, event);
    },

    changedTypeChanged: function(event) {
      // console.log(event);
      const discountType = this.changedTypeDataList.data.find(obj => {
        return obj.id === event
      });

      this.changedText = discountType == null ? "" : discountType.name;
    },

    test: function(event) {
      //console.log(event);
      this.valueProperties = event;
    },

    isValid: function() {
      let cond = true; // this.lastPriceVersionData !== null && this.lastPriceVersionData.expired > this.valueNow;
      // console.log(this.valueNow);
      return cond;
    },

    clickFastView(event) {
      console.log(event);
      this.$refs['fast-view'].show();
    },

    submitSaveVersion: function() {
      // this.tryingToSubmit = true;

      let obj = {
        project_id: this.valueProject,
        for_date: this.$moment().clone().format('YYYY-MM-DD'),
        version: this.valueVersion,
        name: this.valueVersionName,
        booking_color: this.valueBookingColor,
        sold_color: this.valueSoldColor
      };

      // console.log(JSON.stringify(obj));
      priceversionService.insert(obj)
        .then(response => {

        this.$refs['fast-view'].hide();

        if(response.status == 200) {

          this.lastPriceVersionData = response.data;
          this.valueVersion = response.data ? response.data.version + 1 : 1;
          this.lastPriceVersionData['expired'] = this.$moment().clone().add(5, 'days').format('YYYY-MM-DD');

          this.$swal.fire({
            title: i18n.t('general.success.title'),
            text: i18n.t('general.success.message-edit'),
            icon: "success",
            confirmButtonText: i18n.t('general.ok')
          });
        }
      });
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "property-list"
          });

        }
      });

      
    },

    submitSave: function() {

      if(!this.isValid()) {
        this.$swal.fire({
          title: i18n.t('property.update-price.version'),
          text: i18n.t('property.update-price.version') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      }  else if(this.valueProject == 0) {
        this.$swal.fire({
          title: i18n.t('project.text'),
          text: i18n.t('project.text') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      } 

      this.tryingToSubmit = true;

      let obj = {

        price_version_id: this.lastPriceVersionData && this.lastPriceVersionData.id,
        project_id: this.valueProject,
        project_group_id: this.valueGroup,
        properties: this.valueProperties == '' ? "*" : `[${this.valueProperties.map((item) => { return item.id }).join(',')}]`,
        changed: this.valueChanged,
        changed_type: this.valueChangedType,
        exclude: this.valueExclude,
        deduction: this.valueDeduction,
        notation: this.valueNotation,
        
      };

      // console.log(JSON.stringify(obj));
      propertyService.updatePrice(obj)
        .then(response => {
        this.tryingToSubmit = false;

        if(response.status == 200) {

          this.$router.push(this.$route.query.redirectFrom || {
            name: "property-list"
          });

          this.$swal.fire({
            title: i18n.t('general.success.title'),
            text: i18n.t('general.success.message-edit'),
            icon: "success",
            confirmButtonText: i18n.t('general.ok')
          });
        }
      });

      
    },

    clearForm: function() {
      this.valueProject = 0;
      this.valueGroup = 0;
      this.valueProperties = '';
      this.valueChanged = 0;
      this.valueChangedType = 0;
      this.valueExclude = 0;
      this.valueDeduction = 0;
      this.valueNotation = '';
      
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :items="[{
      text: $t('property.list'),
      href: '/general/property',
    }, {text: $t('property.update-price.text'),
        active: true,}]" :title="$t('property.update-price.text')" />

  <Loader :loading="fetchingStats">
      <b-form class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="row" style="margin-bottom: 20px;">
                <div class="col-lg-12">

                  <b-form inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto" v-show="isValid()">
                      <Button v-bind:icon="'bx bx-last-page'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'light'"
                        v-bind:title="`${lastPriceVersionData && lastPriceVersionData.name}`"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-plus-circle'" 
                        v-bind:buttonType="'button'"
                        @click="clickFastView()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('property.update-price.new-version')"  />
                    </div>
                  </b-form>

                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <Select 
                    :text="'name'"
                    @change="projectChanged" 
                    :id="'project_id'"
                    v-model="valueProject"
                    :list="this.projectDataList"
                    :label="'property.project'"
                  /> 
                </div>
                <div class="col-md-3">
                  <Select 
                    :text="'name'"
                    @change="groupChanged" 
                    :id="'property_group_id'"
                    v-model="valueGroup"
                    :first="'general.all'"
                    :list="this.groupDataList"
                    :label="'property.group'"
                  /> 
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <Choosen 
                    @choose="test"
                    :id="'property_id'"
                    :text="'code'"
                    :editable="false"
                    :multiple="true"
                    v-model="valueProperties"
                    :list="this.propertyDataList"
                    :label="'property.text'"  />
                </div>
                <div class="col-md-6">
                  <div class="form-check form-switch form-switch-md mb-3" style="margin-top: 33px;">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="exclude"
                      v-model="valueExclude"
                    />
                    <label class="form-check-label" for="exclude"
                      >{{$t('property.update-price.exclude')}}</label
                    >
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-lg-8">
                      <Input 
                        :type="'number'"
                        :id="'changed'"
                        v-model="valueChanged"
                        :last="this.changedText"
                        :label="'property.price'"  />
                    </div>
                    <div class="col-lg-4">
                      <Select
                        :text="'name'"
                        @change="changedTypeChanged" 
                        :id="'changed_type'"
                        :auto="true"
                        v-model="valueChangedType"
                        :list="this.changedTypeDataList"
                        :label="'sale.as'"
                        /> 
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-check form-switch form-switch-md mb-3" style="margin-top: 33px;">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="deduction"
                      v-model="valueDeduction"
                    />
                    <label class="form-check-label" for="deduction"
                      >{{$t('property.update-price.deducted')}}</label
                    >
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div class="col-lg-12">
                  <Area 
                    :rows="7"
                    :id="'temp_note'"
                    v-model="valueNotation"
                    :label="'property.notation'"  />
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">

                  <b-form inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </b-form>
     
                </div>
              </div>


              <b-modal
                :id="'fast-view'"
                :ref="'fast-view'"
                centered
                size="l"
                :title="$t('property.update-price.new-version')"
                title-class="font-22"
                hide-footer
                :hide-header-close="true"
              >
                <div class="row">
                  <div class="col-lg-12">
                    <div class="card">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-lg-12">
                            <Input 
                              :type="'number'"
                              :id="'version'"
                              :disabled="true"
                              v-model="valueVersion"
                              :label="'property.update-price.version'"  />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-12">
                            <Input 
                              :type="'text'"
                              :id="'name'"
                              v-model="valueVersionName"
                              :label="'property.update-price.name'"  />
                          </div>
                        </div>
                        <div class="row" style="margin-bottom: 40px;">
                          <!-- <div class="col-lg-6">
                            <div class="form-group">
                                <b-form-group
                                    class="mb-3 text-center"
                                    :label="$t('property.update-price.booking-color')"
                                    :label-for="id"
                                >
                                <v-swatches v-model="valueBookingColor"></v-swatches>
                                </b-form-group>
                             </div>
                          </div> -->
                          <div class="col-lg-6">
                            <!-- <ColorPicker color="#f80b" /> -->
                             
                            <div class="form-group">
                                <b-form-group
                                    class="mb-1"
                                    :label="$t('property.update-price.sold-color')"
                                    :label-for="id"
                                >
                                <v-swatches v-model="valueSoldColor"></v-swatches>
                                </b-form-group>
                             </div>


                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-12">

                            <b-form inline class="row gy-2 gx-3 align-items-end">
                              <div class="col-sm-auto">
                                <Button v-bind:icon="'bx bx-save bx-tada'" 
                                  v-bind:buttonType="'button'"
                                  @click="submitSaveVersion()"
                                  v-bind:requesting="tryingToSubmit"
                                  v-bind:title="$t('general.save')"  />
                              </div>
                            </b-form>
              
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-modal>
            </div>
          </div>
        </div>

        
      </b-form>  
    </Loader>
  </Layout>
</template>